import { render, staticRenderFns } from "./mainlandpackage-list.vue?vue&type=template&id=0147079c&"
import script from "./mainlandpackage-list.vue?vue&type=script&lang=ts&"
export * from "./mainlandpackage-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports